/**
 * Providers that belong only in the web build. The `app` configurations replace this file with
 * emptyWebProviders.ts. Empty today. See docs/architecture/build-targets.md.
 */
export const webProviders = [];
